import React from "react";
import SideMenu from "./SideMenu";
import { buildSideMenuItems } from "./menuItems";

export const sideMenuItems = buildSideMenuItems("/admin", {
  includeReceivablesPayables: true,
});

const AdminSideMenu = () => {
  return <SideMenu sideMenuItems={sideMenuItems} />;
};

export default AdminSideMenu;
